module.exports = __webpack_public_path__ + "static/img/1.e3dcbd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/1.png
// module id = UT82
// module chunks = 0